var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2ElectricalSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 5H20a4.23 4.23 0 00-4 4v58a4.18 4.18 0 004 4h36a4.21 4.21 0 004-4V9a4.3 4.3 0 00-4-4zm0 62H20V9h36v58zM29.26 45.45L40 54.3V64h-4v-7.8l-9.28-7.65 2.54-3.1zM28 22.08a9.84 9.84 0 001 4.33 10.001 10.001 0 007 14.14V47h4v-6.45a10 10 0 008-9.8 9.92 9.92 0 00-1-4.34 9.85 9.85 0 001-4.33 10 10 0 00-20 0zm10 14.67a6 6 0 01-6-6v-.66a9.94 9.94 0 0011.93 0v.66a6 6 0 01-5.93 6zm-4.13-10.34a6 6 0 018.27 0 6 6 0 01-8.27 0zM44 22.08v.66a9.94 9.94 0 00-11.93 0v-.66a6 6 0 1112 0H44z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Electrical_Support.4438ecc8.svg";
export { SvgA2ElectricalSupport as ReactComponent };